import { onMounted, onUnmounted } from 'vue'
import { getExecutionPollingBindings } from '@/features/crosschain-buy/execution/polling/controller'

export const useExecutionPollingBindings = (): void => {
  const bindings = getExecutionPollingBindings()
  onMounted(() => {
    bindings.acquire()
  })
  onUnmounted(() => {
    bindings.release()
  })
}
